import React from "react";

export default function Footer() {
  return (
    <div>
      {/* Footer for Desktop */}
      <footer className="w-3/4 mx-auto border border-t border-[#939292] border-x-0 pt-4 text-[gray] hidden lg:flex flex-col ">
        <div className="grid grid-cols-5 gap-2">
          <div className="text-black font-medium text-xs flex flex-col items-start gap-2">
            Shop and Learn
            <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
              Store
            </h5>
            <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
              Mac
            </h5>
            <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
              iPad
            </h5>
            <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
              iPhone
            </h5>
            <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
              Watch
            </h5>
            <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
              Vision
            </h5>
            <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
              Airpods
            </h5>
            <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
              TV & Home
            </h5>
            <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
              Airtag
            </h5>
            <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
              Accessories
            </h5>
            <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
              Gift Cards
            </h5>
            <div className="flex flex-col items-start gap-2 mt-4">
              Apple Wallet
              <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
                Wallet
              </h5>
              <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
                Apple Card
              </h5>
              <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
                Apple Pay
              </h5>
              <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
                Apple Cash
              </h5>
            </div>
          </div>

          <div className="text-black font-medium text-xs flex flex-col items-start gap-2">
            Account
            <h5 className="text-[gray] hover:underline font-normal cursor-pointer text-start">
              Manage Your Apple Account
            </h5>
            <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
              Apple Store Account
            </h5>
            <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
              iCloud.com
            </h5>
            <div className="flex flex-col items-start gap-2 mt-4">
              Entertainment
              <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
                Apple One
              </h5>
              <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
                Apple TV+
              </h5>
              <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
                Apple Music
              </h5>
              <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
                Apple Arcade
              </h5>
              <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
                Apple Fitness+
              </h5>
              <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
                Apple News+
              </h5>
              <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
                Apple Podcasts
              </h5>
              <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
                Apple Books
              </h5>
              <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
                App Store
              </h5>
            </div>
          </div>

          <div className="text-black font-medium text-xs flex flex-col items-start gap-2">
            Apple Store
            <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
              Find a Store
            </h5>
            <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
              Genius Bar
            </h5>
            <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
              Today at Apple
            </h5>
            <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
              Group Reservations
            </h5>
            <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
              Apple Camp
            </h5>
            <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
              Apple Store App
            </h5>
            <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
              Certified Refurbished
            </h5>
            <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
              Apple Trade In
            </h5>
            <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
              Financing
            </h5>
            <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
              Carrier Deals at Apple
            </h5>
            <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
              Order Status
            </h5>
            <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
              Shopping Help
            </h5>
          </div>

          <div className="text-black font-medium text-xs flex flex-col items-start gap-2">
            For Business
            <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
              Apple and Business
            </h5>
            <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
              Shop for Business
            </h5>
            <div className="flex flex-col items-start gap-2 mt-4">
              For Education
              <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
                Apple and Education
              </h5>
              <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
                Shop for K-12
              </h5>
              <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
                Shop for College
              </h5>
            </div>
            <div className="flex flex-col items-start gap-2 mt-4">
              For Healthcare
              <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
                Apple in Healthcare
              </h5>
              <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
                Mac in Healthcare
              </h5>
              <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
                Health on Apple Watch
              </h5>
              <h5 className="text-[gray] hover:underline font-normal cursor-pointer text-start">
                Health Records on iPhone and iPad
              </h5>
            </div>
            <div className="flex flex-col items-start gap-2 mt-4">
              For Government
              <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
                Shop for Government
              </h5>
              <h5 className="text-[gray] hover:underline font-normal cursor-pointer text-start">
                Shop for Veterans and Military
              </h5>
            </div>
          </div>

          <div className="text-black font-medium text-xs flex flex-col items-start gap-2">
            Apple Values
            <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
              Accessibility
            </h5>
            <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
              Education
            </h5>
            <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
              Environment
            </h5>
            <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
              Inclusion and Diversity
            </h5>
            <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
              Privacy
            </h5>
            <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
              Racial Equity and Justice
            </h5>
            <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
              Supply Chain
            </h5>
            <div className="flex flex-col items-start gap-2 mt-4">
              About Apple
              <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
                Newsroom
              </h5>
              <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
                Apple Leadership
              </h5>
              <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
                Career Opportunities
              </h5>
              <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
                Investors
              </h5>
              <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
                Ethics & Compliance
              </h5>
              <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
                Events
              </h5>
              <h5 className="text-[gray] hover:underline font-normal cursor-pointer">
                Contact Apple
              </h5>
            </div>
          </div>
        </div>

        <div className="text-xs text-start mt-9">
          <h4>
            More ways to shop: &nbsp;
            <span className="text-blue-600 cursor-pointer underline text-[14px]">
              Find an Apple Store
            </span>{" "}
            &nbsp; or &nbsp;
            <span className="text-blue-600 cursor-pointer underline text-[14px]">
              other retailer
            </span>{" "}
            &nbsp; near you. Or call &nbsp;
            <span className="text-blue-600 cursor-pointer underline text-[14px]">
              1-800-MY-APPLE
            </span>{" "}
            <span className=" text-[14px]">(1-800-692-7753).</span>
          </h4>
        </div>

        <div className=" border-t border-[#9c9c9c] mt-6  py-4 flex flex-row justify-between items-start text-xs">
          <div className="flex flex-row flex-wrap gap-y-1">
            <h4 className="mr-8">
              Copyright © 2025 Apple Inc. All rights reserved.
            </h4>
            <div className="cursor-pointer">
              <span className="hover:underline border-r border-[gray] px-2 font-medium">
                Privacy Policy
              </span>
              <span className="hover:underline border-r border-[gray] px-2 font-medium">
                {" "}
                Terms of Use
              </span>
              <span className="hover:underline border-r border-[gray] px-2 font-medium">
                {" "}
                Sales and Refunds
              </span>
              <span className="hover:underline border-r border-[gray] px-2 font-medium">
                {" "}
                Legal
              </span>
              <span className="hover:underline px-2 font-medium">
                {" "}
                Site Map
              </span>
            </div>
          </div>

          <div className="hover:underline cursor-pointer text-sm font-medium whitespace-nowrap">
            United States
          </div>
        </div>
      </footer>

      {/* Footer for Mobile */}
      <footer className="w-11/12 mx-auto border-t  border-[#939292] border-x-0 pt-4 text-sm lg:hidden">
        <div className="pt-2 pb-2  border-b border-[#c4c3c3] flex flex-row justify-between">
          Shop and learn
          <i className="fa-solid fa-angle-down"></i>
        </div>
        <div className="pt-2 pb-2  border-b border-[#c4c3c3] flex flex-row justify-between">
          Apple wallet
          <i className="fa-solid fa-angle-down"></i>
        </div>
        <div className="pt-2 pb-2  border-b border-[#c4c3c3] flex flex-row justify-between">
          Account
          <i className="fa-solid fa-angle-down"></i>
        </div>
        <div className="pt-2 pb-2  border-b border-[#c4c3c3] flex flex-row justify-between">
          Entertainment
          <i className="fa-solid fa-angle-down"></i>
        </div>
        <div className="pt-2 pb-2  border-b border-[#c4c3c3] flex flex-row justify-between">
          Apple staore
          <i className="fa-solid fa-angle-down"></i>
        </div>
        <div className="pt-2 pb-2  border-b border-[#c4c3c3] flex flex-row justify-between">
          For business
          <i className="fa-solid fa-angle-down"></i>
        </div>
        <div className="pt-2 pb-2  border-b border-[#c4c3c3] flex flex-row justify-between">
          For Education
          <i className="fa-solid fa-angle-down"></i>
        </div>
        <div className="pt-2 pb-2  border-b border-[#c4c3c3] flex flex-row justify-between">
          For Healthcare
          <i className="fa-solid fa-angle-down"></i>
        </div>
        <div className="pt-2 pb-2  border-b border-[#c4c3c3] flex flex-row justify-between">
          For Government
          <i className="fa-solid fa-angle-down"></i>
        </div>
        <div className="pt-2 pb-2  border-b border-[#c4c3c3] flex flex-row justify-between">
          Apple values
          <i className="fa-solid fa-angle-down"></i>
        </div>
        <div className="pt-2 pb-2  border-b border-[#c4c3c3] flex flex-row justify-between">
          About Apple
          <i className="fa-solid fa-angle-down"></i>
        </div>

        <div className="text-xs text-start mt-9 text-[gray]">
          <h4>
            More ways to shop: &nbsp;
            <span className="text-blue-600 cursor-pointer underline text-[14px]">
              Find an Apple Store
            </span>{" "}
            &nbsp; or &nbsp;
            <span className="text-blue-600 cursor-pointer underline text-[14px]">
              other retailer
            </span>{" "}
            &nbsp; near you. Or call &nbsp;
            <span className="text-blue-600 cursor-pointer underline text-[14px]">
              1-800-MY-APPLE
            </span>{" "}
            <span className=" text-[14px]">(1-800-692-7753).</span>
          </h4>
        </div>

        <div className="hover:underline cursor-pointer text-sm font-medium whitespace-nowrap text-[gray] text-start py-4">
          United States
        </div>
        <div>
          <h4 className="text-[gray] text-start">
            Copyright © 2025 Apple Inc. All rights reserved.
          </h4>
        </div>

        <div className="cursor-pointer text-[gray] text-start pb-4">
          <span className="hover:underline border-r border-[gray] pr-2 font-medium">
            Privacy Policy
          </span>
          <span className="hover:underline border-r border-[gray] px-2 font-medium">
            {" "}
            Terms of Use
          </span>
          <span className="hover:underline border-r border-[gray] px-2 font-medium">
            {" "}
            Sales and Refunds
          </span>
          <span className="hover:underline border-r border-[gray] px-2 font-medium">
            {" "}
            Legal
          </span>
          <span className="hover:underline px-2 font-medium"> Site Map</span>
        </div>
      </footer>
    </div>
  );
}
